import { render, staticRenderFns } from "./scMoreInfoDownloadWidget.vue?vue&type=template&id=3b9f8219&"
import script from "./scMoreInfoDownloadWidget.vue?vue&type=script&lang=js&"
export * from "./scMoreInfoDownloadWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports